import { Check } from 'lucide-react';

/**
 * Small wrapper around a form field showing:
 *   - red asterisk when `required`
 *   - error message in red below
 *   - green checkmark when value is non-empty AND no error
 *
 * Props:
 *   label, required, error (string|undefined), filled (bool — true = show check),
 *   testId, children
 */
export default function FieldShell({
  label,
  required = false,
  error = '',
  filled = false,
  hint = '',
  testId,
  children,
  labelClass = 'text-xs',
}) {
  return (
    <div data-testid={testId}>
      {label && (
        <label className={`${labelClass} text-[#1A3330] font-medium block mb-1`}>
          {label}
          {required && <span className="text-[#D3544E]"> *</span>}
        </label>
      )}
      <div className="relative">
        {children}
        {filled && !error && (
          <Check
            className="w-4 h-4 text-[#2E8B57] absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none"
            data-testid={testId ? `${testId}-check` : undefined}
          />
        )}
      </div>
      {error && (
        <p
          className="text-[10px] text-[#D3544E] mt-1"
          data-testid={testId ? `${testId}-error` : undefined}
        >
          {error}
        </p>
      )}
      {hint && !error && (
        <p className="text-[10px] text-[#4A6B68] mt-1">{hint}</p>
      )}
    </div>
  );
}
